
/**
 * @deprecated We need to get rid of all of this
 */
import React from 'react';
import moment from 'moment';
import styled from '@emotion/styled';
import { useDispatch } from 'react-redux';
import { operateHolder } from './Title';
import { START_TIME, END_TIME } from './redux';
import { colors } from './colorScheme';

/**
 * @deprecated Use the new one from deci core
 */
export const TempTimeline = React.memo(({ node, value, width, className, onClick, usePercentageWidth, title }) => {
  return (
    <div>HARD REMOVED - USE THE NEW ONE</div>
  );
});
TempTimeline.displayName = 'DecisionDashboard/Reports/Details/TempTimeline';

export * from './Title';
